export const EMPTY_DATA = {
  v: 1,
  company: { name: '', address: '', contact: '', gstin: '' },
  clients: [],     // [{ id, code, name, lines: [], gst }]
  counter: 1,
  drafts: {},      // { challan: {...} } in-progress form state
  lastChallan: null, // last generated form values, for "duplicate from previous"
  history: [],     // [{ id, challanNo, dateStr, customerName, total, snapshot, generatedAt }]
};

export function newId() {
  return Math.random().toString(36).slice(2, 10);
}

export function downloadDataFile(data, filename = 'pinaki-data.json') {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function readDataFile(file) {
  const text = await file.text();
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error('File is not valid JSON');
  }
  if (!parsed || typeof parsed !== 'object') {
    throw new Error('File does not look like a Pinaki data file');
  }
  return parsed;
}
